import * as React from "react";
import { Form, Tab, Table, Header, TabPane, TableCell, TableRow, TableFooter, TableBody, TableHeader, TableHeaderCell, FormField, FormGroup, FormSelect, FormInput, FormCheckbox, FormTextArea } from "@/components/bp/bp-ui";
import { IDropdownItem } from "../IDropdownItem";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    TimeScale,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js';
import 'chartjs-adapter-moment';
import { Bar, Line } from 'react-chartjs-2';
import moment from "moment";
import { ClientResources, LabClient, LabEditFullModel, RunTypeModel, LabUsageDetail, NamedDateRange, AlleleFormat, ParameterTypes, SharingSampleType } from "@app/api2/api";
import { LabAgenciesViewFC } from "./LabAgenciesView";
import { TimeZonePicker } from "../TimeZonePicker";
import { LabDropInDataView } from "./LabDropInDataView";
import { LabReportingView } from "./LabReportingView";
import ReactDatePicker from "react-datepicker";
import { LabPrintingOptions } from "./LabPrintingOptions";
import { PageHeader } from "@common/PageHeader";
import { replaceInString } from "@common/Utils";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { areYouSure } from "../AreYouSure";
import { ReportTextTemplate } from "./ReportTextTemplate";
import { toAlleleFormatName, toSharingSampleTypeName } from "@common/AlleleFormatNames";
import { HandlerRegistry } from "../CaseRun/RunTypes/HandlerRegistry";
import { LabMarkerSettingsDialog } from "./LabMarkerSettingsDialog";
import { TranslationContext } from "../Contexts/TranslationContext";
import { RoutedTab } from "../CaseRun/Details/RoutedTab";
import { BPButton } from "@/components/bp/bpbutton";
import { BPCheckbox } from "@/components/bp/bpcheckbox";
import { BPContainer } from "@/components/bp/bpcontainer";

class LabDetailState {
    timeZoneList: any[];
    renderedTimeZoneList: IDropdownItem<string>[];
    loading: boolean = true;
    showServerErrors: boolean;
    serverErrors: string[];
    timeZoneSearch: string;
    currentMainTab: number;
    currentParameterTab: number;
    lab: LabEditFullModel;

    showKitMarkerSettings: boolean = false;
    kitId: number;
    kitName: string;
}


interface ILabDetailProps {
    labId: number;
    canEditLab: boolean;
    // baseUrl: string;
    // translation: ClientResources;
}

export class LabDetailView extends React.Component<ILabDetailProps, LabDetailState> {
    DateRanges;
    private translation: ClientResources;

    private labClient = new LabClient();

    constructor(props, context) {
        super(props, context);

        var state = new LabDetailState();
        state.lab = { active: false, canEditProvisioning: false, dedicatedWorkers: 1, isDemo: false, isReadOnly: false, lowPriorityWorkers: 0, populations: [], kits: [], runTypes: [], };

        this.state = state;
    }

    public async componentDidMount(): Promise<any> {
        const lab = await this.labClient.get(this.props.labId);

        this.setState({
            lab: lab,
            loading: false,
        });
    }

    @areYouSure(() => {
        return {
            title: window.translation.common.confirmDisable,
            message: window.translation.labView.disable
        }
    })
    private async disable() {
        await this.labClient.disable(this.props.labId)
        window.location.href = buildUrl(AppRoutes.Lab, {})
    }

    @areYouSure(() => {
        return {
            title: window.translation.common.confirmEnable,
            message: window.translation.labView.enable
        }
    })
    private async enable() {
        await this.labClient.enable(this.props.labId)
        window.location.href = buildUrl(AppRoutes.Lab, {})
    }

    public render() {
        const updateMainTab = (e, { activeIndex }) => {
            this.setState({ currentMainTab: activeIndex });
        };
        // const basePath = buildUrl(Routes.LabDetails, { labId: this.props.labId })
        const basePath = '';

        const mainTabs = [
            { path: basePath + '/', enabled: true, exact: true, to: basePath + '..', menuItem: window.translation.lab.labInformation, render: () => this.renderLabInfoPanel() },
            { path: basePath + 'kits', enabled: true, exact: true, to: basePath + '../kits', menuItem: window.translation.common.kits, render: () => this.renderKitsPanel() },
            { path: basePath + 'populations', enabled: true, exact: true, to: basePath + '../populations', menuItem: window.translation.common.populations, render: () => this.renderPopulationPanel() },
            { path: basePath + 'parameters', enabled: true, exact: true, to: basePath + '../parameters', menuItem: window.translation.common.parameters, render: () => this.renderParametersPanel() },
            { path: basePath + 'usage', enabled: true, exact: true, to: basePath + '../usage', menuItem: window.translation.lab.usage, render: () => this.renderUsagePanel() },
            { path: basePath + 'agencies', enabled: true, exact: true, to: basePath + '../agencies', menuItem: window.translation.lab.agencies, render: () => this.renderAgenciesPanel() },
            { path: basePath + 'dropindata', enabled: true, exact: true, to: basePath + '../dropindata', menuItem: window.translation.lab.dropInData, render: () => this.renderDropInPanel() },
            { path: basePath + 'reporting', enabled: true, exact: true, to: basePath + '../reporting', menuItem: window.translation.lab.reporting, render: () => this.renderReporting() },
            { path: basePath + 'report-text', enabled: true, exact: true, to: basePath + '../report-text', menuItem: window.translation.reportTexts.reportTextTemplate, render: () => this.renderReportText() },
            { path: basePath + 'print-options', enabled: true, exact: true, to: basePath + '../print-options', menuItem: window.translation.lab.casePrintOptions, render: () => this.renderPrintOptions() },
        ];

        // const panes = mainTabs.map((t, i) => {
        //     return {
        //         menuItem: {
        //             as: NavLink,
        //             id: `tab${i}`,
        //             content: t.menuItem,
        //             to: t.path,
        //             exact: true,
        //             key: `tab${i}`
        //         },
        //         pane: (
        //             <Route
        //                 path={t.path}
        //                 key={`rkey_${i}`}
        //                 render={t.render}
        //             />
        //         )
        //     };
        // });

        // // Required to get a correct tab opened by default
        // const defaultActiveIndex = panes.findIndex(pane => {
        //     return !!matchPath(window.location.pathname, {
        //         path: pane.menuItem.to,
        //         exact: true
        //     });
        // });

        return (
            <BPContainer>
                <PageHeader header={replaceInString(window.translation.labView.labDetail, { '{labName}': this.state?.lab.name })}
                    buttons={[
                        { showIf: this.props.canEditLab, label: window.translation.common.edit, to: buildUrl(AppRoutes.LabEdit, { labId: this.props.labId }) },
                        {
                            showIf: this.props.canEditLab,
                            label: this.state.lab.active ? window.translation.common.disable : window.translation.common.active,
                            action: this.state.lab.active ? () => this.disable() : () => this.enable(),
                            negative: true
                        },

                    ]}
                />

                {/* <Tab renderActiveOnly={false} defaultActiveIndex={defaultActiveIndex} panes={panes} menu={{ pointing: false, vertical: true, tabular: true }} /> */}
                <RoutedTab menu={{ pointing: false, vertical: true, tabular: true }} tabs={mainTabs} />
            </BPContainer>
        );
    }

    private renderKitsPanel() {
        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.kit.name}</TableHeaderCell>
                            <TableHeaderCell>{t.common.enabledQuestion}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.state.lab.kits.map((k, i) => {
                            return (
                                <TableRow key={k.kitId}>
                                    <TableCell><a href="" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.setState({ kitId: k.kitId, kitName: k.fullName, showKitMarkerSettings: true })
                                    }}>{k.fullName}</a></TableCell>
                                    <TableCell><BPCheckbox checked={k.enabled} /></TableCell>
                                </TableRow>);
                        })}
                    </TableBody>
                </Table>
                <LabMarkerSettingsDialog isOpen={this.state.showKitMarkerSettings} labId={this.props.labId} kitId={this.state.kitId} kitName={this.state.kitName}
                    onClose={() => { this.setState({ showKitMarkerSettings: false }) }}
                    onOk={async (values) => {
                        // console.log(values);
                        await this.labClient.setKitMarkerSettings(this.props.labId, this.state.kitId, values);
                        this.setState({ showKitMarkerSettings: false })
                    }}
                    onOpen={() => { }}
                />
            </TabPane>}</TranslationContext.Consumer>);
    }


    private renderPopulationPanel() {
        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.population.name}</TableHeaderCell>
                            <TableHeaderCell>{t.common.enabledQuestion}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.state.lab.populations.map((value, index) => (
                            <TableRow key={value.populationId}>
                                <TableCell>{value.populationName}</TableCell>
                                <TableCell><BPCheckbox checked={value.enabled} /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TabPane>}</TranslationContext.Consumer>
        );
    }

    private renderParametersTab = (runType: RunTypeModel) => {
        const runtypeHandler = HandlerRegistry.getRunTypeHandler(runType.runType)


        return (<TranslationContext.Consumer>{t =>
            <TabPane>
                <Table compact>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.common.parameter}</TableHeaderCell>
                            <TableHeaderCell>{t.common.value}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {runType.parameters.map((m) => {
                            const hasCustomRenderer = runtypeHandler?.canRenderParameter(m.parameter) && runtypeHandler?.renderParameterLabSettings({
                                parameter: m.parameter, value: m.defaultValue, labId: this.props.labId
                            }) != null;

                            return (
                                <TableRow key={`${runType.runType}_${m.parameter}`}>
                                    <TableCell>{t.parameter.names[m.parameter]}</TableCell>
                                    <TableCell>
                                        {hasCustomRenderer &&
                                            <FormField>
                                                {runtypeHandler?.renderParameterLabSettings({
                                                    readOnly: true, parameter: m.parameter, value: m.defaultValue, onChange: v => { }, labId: this.props.labId
                                                })}
                                            </FormField>}

                                        {!hasCustomRenderer && (m.parameterType === ParameterTypes.Number || m.parameterType === ParameterTypes.Integer) &&
                                            <FormInput value={m.defaultValue} />}
                                        {!hasCustomRenderer && m.parameterType === ParameterTypes.String &&
                                            <FormInput value={m.defaultValue} />}
                                        {!hasCustomRenderer && m.parameterType === ParameterTypes.Boolean &&
                                            <BPCheckbox checked={m.defaultValue === "1"} />}
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TabPane>}</TranslationContext.Consumer>);
    };

    private renderParametersPanel() {

        const updateParameterTab = (e, { activeIndex }) => {
            this.setState({ currentParameterTab: activeIndex });
        };

        const parametersTabs = this.state.lab.runTypes.map((t) => ({
            menuItem: window.translation.runType[t.runType] || 'undefined',
            render: () => this.renderParametersTab(t)
        }));
        return (
            <TabPane>
                <Tab menu={{ vertical: true, tabular: "left" }} panes={parametersTabs} onTabChange={updateParameterTab}
                    activeIndex={this.state.currentParameterTab}>
                </Tab>
            </TabPane>);
    }

    private renderAgenciesPanel() {
        return (
            <TabPane>
                <LabAgenciesViewFC readOnly={true} labId={this.props.labId} />
            </TabPane>
        );
    }

    private renderDropInPanel() {
        return (
            <TabPane>
                <LabDropInDataView readOnly={true} labId={this.props.labId} />
            </TabPane>
        );
    }

    private renderReporting() {
        return (
            <TabPane>
                <LabReportingView readOnly={true} labId={this.props.labId} />
            </TabPane>
        );
    }

    private renderReportText() {
        return (
            <TabPane>
                <ReportTextTemplate readOnly={true} labId={this.props.labId} />
            </TabPane>
        );
    }

    private renderPrintOptions() {
        return (
            <TabPane>
                <LabPrintingOptions readOnly={true} labId={this.props.labId} model={this.state.lab.caseRunPrintingOptions} />
            </TabPane>
        );
    }


    private renderLabInfoPanel() {
        return (<TranslationContext.Consumer>{t =>
            <Form>
                <TabPane>
                    <FormInput name="name" label={t.lab.name} value={this.state.lab.name} />
                    <FormField>
                        <label>{t.lab.timeZone}</label>
                        <TimeZonePicker name="timeZone" readOnly={true} value={this.state.lab.timeZone} country={this.state.lab.country}
                            onChange={() => { }} />

                    </FormField>
                    <FormInput name="locale" label={t.common.language} value={this.state.lab.fullLocaleName} />
                    <FormCheckbox name="demoLab" label={t.lab.demoLab} checked={this.state.lab.isDemo} />
                    <FormCheckbox name="readOnlyLab" label={t.lab.readOnlyLab} checked={this.state.lab.isReadOnly} />
                    <FormInput name="lowPriorityWorkers" label={t.lab.maximumLowPriority} value={this.state.lab.lowPriorityWorkers} />
                    <FormInput name="dedicatedWorkers" label={t.lab.maximumDedicated} value={this.state.lab.dedicatedWorkers} />
                    <FormInput name="taskSlotsPerNode" label={t.lab.taskSlotsPerNode} value={this.state.lab.taskSlotsPerNode ?? 1} />
                    <FormInput name="vmSize" label={t.lab.vmSize} value={this.state.lab.vmSize ?? ""} />
                    <FormTextArea name="autoscaleFormula" label={t.lab.autoscaleFormula} value={this.state.lab.autoscaleFormula ?? ""} />
                    <FormGroup grouped>
                        <label>{t.common.alleleFormat}</label>
                        <FormCheckbox readOnly name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.CE_RU)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.CE_RU)} />
                        <FormCheckbox readOnly name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.LUS)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.LUS)} />
                        <FormCheckbox readOnly name="defaultAlleleFormats" label={toAlleleFormatName(AlleleFormat.LUSP)} checked={this.state.lab.defaultAlleleFormats?.some(x => x == AlleleFormat.LUSP)} />
                    </FormGroup>
                    <FormGroup grouped>
                        <label>{'Shared Samples'}</label>
                        {/* <Form.Checkbox  name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.None)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.None)}  /> */}
                        <FormCheckbox name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.All)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.All)} />
                        <FormCheckbox name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.Evidence)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.Evidence)} />
                        <FormCheckbox name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.Reference)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.Reference)} />
                        <FormCheckbox name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.ForensicEnrollments)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.ForensicEnrollments)} />
                        <FormCheckbox name="sharedSampleTypes" label={toSharingSampleTypeName(SharingSampleType.QualityCases)} checked={this.state.lab.sharedSampleTypes?.some(x => x == SharingSampleType.QualityCases)} />

                    </FormGroup>
                </TabPane>
            </Form>}</TranslationContext.Consumer>
        );
    }

    private renderUsagePanel() {
        return (
            <TabPane>
                <LabUsageView labId={this.props.labId} translation={window.translation} />
            </TabPane>
        );
    }

}

interface ILabUsageProps {
    labId: number;
    translation: ClientResources;
}

interface IGraphPoint {
    x: Date;
    y: number;
}

class LabUsageState {
    dateRange: NamedDateRange = NamedDateRange.Last30;

    startDate: Date;
    endDate: Date;

    usageDetail: LabUsageDetail[] = [];

    byDayRuns: IGraphPoint[] = [];
    byDayMinutes: IGraphPoint[] = [];
}




class LabUsageView extends React.Component<ILabUsageProps, LabUsageState> {
    DateRanges;
    chartOptions;
    translationsContext: React.Context<ClientResources>;
    labClient = new LabClient();

    constructor(props, context) {
        super(props, context);
        this.state = new LabUsageState();
        this.translationsContext = React.createContext(this.props.translation);
        // register Chart.js components for v3+/v4
        ChartJS.register(
            CategoryScale,
            LinearScale,
            PointElement,
            LineElement,
            BarElement,
            TimeScale,
            Title,
            Tooltip,
            Legend,
            Filler
        );
        this.DateRanges = [
            { key: NamedDateRange.Last30, text: this.props.translation.lab.last30Days, value: NamedDateRange.Last30, },
            { key: NamedDateRange.Last60, text: this.props.translation.lab.last60Days, value: NamedDateRange.Last60, },
            { key: NamedDateRange.Last90, text: this.props.translation.lab.last90Days, value: NamedDateRange.Last90, },
            { key: NamedDateRange.Thismonth, text: this.props.translation.lab.thisMonth, value: NamedDateRange.Thismonth, },
            { key: NamedDateRange.Lastmonth, text: this.props.translation.lab.lastMonth, value: NamedDateRange.Lastmonth, },
            { key: NamedDateRange.Custom, text: this.props.translation.lab.custom, value: NamedDateRange.Custom, },
        ];

        this.chartOptions = {
            responsive: true,
            scales: {
                x: {
                    type: 'time',
                    time: { unit: 'day' },
                    ticks: { autoSkip: true },
                },
                usageMinutes: {
                    type: 'linear',
                    display: true,
                    position: 'right',
                    title: {
                        display: true,
                        text: this.props.translation.lab.usageMinutes,
                    },
                },
                usageRuns: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    title: {
                        display: true,
                        text: this.props.translation.lab.totalRuns,
                    },
                },
            },
        };
    }

    async componentDidMount(): Promise<any> {
        this.getRangeData(this.state.dateRange);
    }

    async getRangeData(range: NamedDateRange, from?: Date, to?: Date): Promise<any> {

        const results = await this.labClient.getUsageByDay(this.props.labId, range, from, to);

        this.setState({
            startDate: new Date(results.startDate),
            endDate: new Date(results.endDate),
            usageDetail: results.labUsageDetail,
            byDayRuns: results.labUsageByDay.map((v) => ({ x: v.date, y: v.runCount })),
            byDayMinutes: results.labUsageByDay.map((v) => ({ x: v.date, y: v.totalRunMinutes })),
        });
    }

    enumerateDaysBetweenDates(startDate, endDate) {
        var dates = [];

        var currDate = moment(startDate).startOf('day');
        var lastDate = moment(endDate).startOf('day');

        while (currDate.add(1, 'days').diff(lastDate) < 0) {
            dates.push(currDate.clone().toDate());
        }

        return dates;
    };

    changeRange = (e, { value }) => {
        //console.log(value)
        let start = new Date();
        let end = new Date();
        let now = new Date();

        switch (value as NamedDateRange) {
            case NamedDateRange.Last30:
                start.setDate(now.getDate() - 30);
                end.setDate(now.getDate());
                break;
            case NamedDateRange.Last60:
                start.setDate(now.getDate() - 60);
                end.setDate(now.getDate());
                break;
            case NamedDateRange.Last90:
                start.setDate(now.getDate() - 90);
                end.setDate(now.getDate());
                break;
            case NamedDateRange.Thismonth:
                start = new Date(now.getFullYear(), now.getMonth(), 1);
                end.setDate(now.getDate());
                break;
            case NamedDateRange.Lastmonth:
                let lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                start = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
                end = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, -1);
                break;
            case NamedDateRange.Custom:
        }

        if (value != NamedDateRange.Custom) {
            this.setState({ dateRange: value, startDate: start, endDate: end });
            this.getRangeData(value, null, null);
        } else {
            this.setState({ dateRange: value });
            //this.getRangeData(value, start, end);
        }
    };

    render() {

        const data = {
            labels: this.state.byDayRuns.map((r) => r.x.toString()),
            datasets: [
                {
                    type: "line",
                    label: this.props.translation.lab.usage,
                    data: this.state.byDayRuns.map((r) => r.y),
                    yAxisID: "usageRuns",
                    fill: false,
                    borderColor: '#EC932F',
                    backgroundColor: '#EC932F',
                    pointBorderColor: '#EC932F',
                    pointBackgroundColor: '#EC932F',
                    pointHoverBackgroundColor: '#EC932F',
                    pointHoverBorderColor: '#EC932F',
                },
                {
                    type: "line",
                    label: this.props.translation.lab.usageMinutes,
                    data: this.state.byDayMinutes.map((r) => r.y),
                    yAxisID: "usageMinutes",
                    fill: false,
                    backgroundColor: '#71B37C',
                    borderColor: '#71B37C',
                    hoverBackgroundColor: '#71B37C',
                    hoverBorderColor: '#71B37C',
                }

            ]
        }
        return (<TranslationContext.Consumer>{t =>
            <div>
                <Form>
                    <FormGroup>
                        <FormSelect label={t.lab.dateRange} value={this.state.dateRange} options={this.DateRanges} onChange={this.changeRange} />
                        {this.state.dateRange == NamedDateRange.Custom &&
                            <React.Fragment>
                                <FormField>
                                    <label>Start Date</label>
                                    <ReactDatePicker autoComplete="off" placeholderText="Start Date" className="ui input" name="startDate" selected={this.state.startDate} onChange={(ev) => this.setState({ startDate: ev as Date })} />
                                </FormField>
                                <FormField>
                                    <label>End Date</label>
                                    <ReactDatePicker autoComplete="off" placeholderText="End Date" name="endDate" selected={this.state.endDate} onChange={(ev) => this.setState({ endDate: ev as Date })} />
                                </FormField>
                                <FormField>
                                    <label>&nbsp;</label>
                                    <BPButton onClick={() => this.getRangeData(NamedDateRange.Custom, this.state.startDate, this.state.endDate)}>Search</BPButton>
                                </FormField>
                            </React.Fragment>
                        }
                    </FormGroup>
                </Form>
                <Header as="h3">{replaceInString(t.lab.showingDataFromTo, { '{startDate}': moment(this.state.startDate).format("L"), '{endDate}': moment(this.state.endDate).format("L") })}</Header>
                <Bar options={this.chartOptions} data={data as any} />
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>{t.common.case}</TableHeaderCell>
                            <TableHeaderCell>{t.common.run}</TableHeaderCell>
                            <TableHeaderCell>{t.lab.jobType}</TableHeaderCell>
                            <TableHeaderCell>{t.common.created}</TableHeaderCell>
                            <TableHeaderCell>{t.common.completed}</TableHeaderCell>
                            <TableHeaderCell>{t.lab.timeTaken}</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {this.state.usageDetail.map((value, index) => (
                            <TableRow key={index}>
                                <TableCell><a href={value.caseUrl}>{value.caseName}</a></TableCell>
                                <TableCell>{value.runId !== 0 && <a href={value.runUrl}>{value.runId}</a>}</TableCell>
                                <TableCell>{value.jobType}</TableCell>
                                <TableCell>{moment(value.created).format("L LTS")}</TableCell>
                                <TableCell>{value.completedTime && moment(value.completedTime).format("L LTS")}</TableCell>
                                <TableCell>{value.timeTakenMinutes.toLocaleString(undefined, { maximumFractionDigits: 1 })}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell>{t.lab.totalJobs}</TableCell>
                            <TableCell>{this.state.usageDetail.length}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell>{t.lab.totalTime}</TableCell>
                            <TableCell>{this.state.usageDetail.reduce((sum, value) => sum + value.timeTakenMinutes, 0).toLocaleString(undefined, { maximumFractionDigits: 1 })}</TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </div>}</TranslationContext.Consumer>);
    }
}


